export default "__VITE_ASSET__lAx5qy$p__"